//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbProductTile from '@/elements/product-tile/rb-product-tile.vue'

export default {
  name: 'rb-algolia-base-editorial-products',
  components: {
    RbProductTile,
  },
  props: {
    dataElementId: {
      type: String,
      default: '',
    },
    products: {
      type: Array,
      default: () => [],
    },
    internalContent: {
      type: Boolean,
      default: false,
    },
    wishlistIconIsVisible: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    columnsOfNextSlide() {
      return this.overrideColumnsOfNextSlide ?? 2
    },
    slidesPerViewDesktop() {
      return this.overrideSlidesPerView ? this.overrideSlidesPerView : 3
    },
    slidesPerViewMobile() {
      return this.overrideSlidesPerView ? this.overrideSlidesPerView : 1
    },
    hasPagination() {
      const comparison = this.overrideSlidesPerView ?? 3
      return this.products.length > comparison
    },
  },
  inject: ['overrideColumnsOfNextSlide', 'overrideSlidesPerView'],
}
